This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="redirect"></div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import router from "@/router";

@Options({
  mounted() {
    router.push("/game");
  },
})
export default class GameRedirect extends Vue {}
</script>
